import { render, staticRenderFns } from "./num5or10.vue?vue&type=template&id=4d4e6452&"
import script from "./num5or10.vue?vue&type=script&lang=js&"
export * from "./num5or10.vue?vue&type=script&lang=js&"
import style0 from "./num5or10.vue?vue&type=style&index=0&id=4d4e6452&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports